// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1vOvW","right":"styles_right__3hU62"};